import { PropTypes } from 'prop-types';

import { useAuthentication } from '@zenbusiness/application-commons-authentication';

import useFlowState from '#client/hooks/flow/useFlowState';
import { CheckoutCard } from '#client/pages/Checkout/components/CheckoutCard';
import { CHECKOUT } from '#client/pages/Checkout/constants';

import FilingGuaranteeCallout from './FilingGuaranteeCallout';
import Form from './Form';
import Summary from './Summary';

function BusinessCheckoutCard({ businessCardProps, onContinue }) {
  const { authenticated } = useAuthentication();
  const { accountUuid, businessInfo } = useFlowState();
  const { businessInfoFields, contactInfoFields } = businessCardProps || {};

  const hasAccount = authenticated || accountUuid;
  const hasBusiness = businessInfo.businessEntityUuid;
  const hasAccountAndBusiness = Boolean(hasAccount && hasBusiness);

  return (
    <CheckoutCard step={CHECKOUT.STEP.BUSINESS}>
      <CheckoutCard.Active>
        {hasAccountAndBusiness ? (
          <Summary onContinue={onContinue} />
        ) : (
          <Form
            businessFields={businessInfoFields}
            contactFields={contactInfoFields}
            isBusinessEditable={!hasBusiness}
            isContactEditable={!hasAccount}
            onContinue={onContinue}
          />
        )}
        <FilingGuaranteeCallout />
      </CheckoutCard.Active>

      <CheckoutCard.Complete hideEdit={hasAccountAndBusiness}>
        <Summary />
      </CheckoutCard.Complete>

      <CheckoutCard.Incomplete />
    </CheckoutCard>
  );
}

BusinessCheckoutCard.propTypes = {
  businessCardProps: PropTypes.shape({
    businessInfoFields: PropTypes.object,
    contactInfoFields: PropTypes.object
  }),
  onContinue: PropTypes.func.isRequired
};

export default BusinessCheckoutCard;
